import { Component, OnInit, OnDestroy, ViewChild, HostListener, NgZone,  } from '@angular/core';
import { Router,  ActivatedRoute, ParamMap } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, throwError } from 'rxjs';
import { map, shareReplay, take, filter, switchMap } from 'rxjs/operators';
import { LocationStrategy, PlatformLocation, Location } from '@angular/common';
import {UserAccountService} from '../../../../core/services/user-account.service';
import { Group } from '../../models/group';
import {GroupService } from '../../services/group.service'
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogConfig, ConfirmDialogComponent } from '../../components/confirm-dialog/confirm-dialog.component';
import { AddUserComponent } from '../../components/add-user/add-user-component';
import { AddResourceComponent } from '../../components/add-resource/add-resource-component';
import { AlertDialog, AlertDialogConfig } from '../../components/alert/dialog';


@Component({
  standalone: false,
    selector: 'app-edit-group',
    templateUrl: './edit-group.component.html',
    styleUrls: ['./edit-group.component.scss']
})
export class EditGroupComponent implements OnInit {
   loading: Boolean= true;
   group_id: string = '';
   group: Group = new Group();


  selectedTab = 0;
  userList: Array<any> = [];
   userListDisplayedColumns: Array<string> = ['email', 'roles_list',  'delete'];

  resourcesList: Array<any> = [];
   resourcesListDisplayedColumns: Array<string> = ['name',  'delete'];


    constructor(
      private readonly dialog_: MatDialog,
      private router: Router,
      private route:  ActivatedRoute,
      location:Location,
      private breakpointObserver: BreakpointObserver,
      private userAccountService: UserAccountService,
      private groupService: GroupService,

      private readonly ngZone_: NgZone) {
    }

    ngOnInit(): void {

      this.loading = true;
      this.route.params.subscribe(
        params => {
          this.group_id = params['id'] || '';
          this.groupService.getById(this.group_id)
          .subscribe(result => {
            this.group = result;

            this.groupService.getUsersOf(this.group_id).subscribe(result => {
              this.userList =  result
              this.loading = false;
            })
            this.groupService.getResourcesOf(this.group_id).subscribe(result => {
              this.resourcesList =  result.map( (resource: any) => {return {name: resource}})
            })
          });
          }
        );
        }


        isUserGrantedToEdit(instance: any){
      return true
    }




    handleAddUserDialog(): void {
      const dialogData = {data: {groups: [this.group_id],}};
      const dialogDef = this.dialog_.open(AddUserComponent, dialogData);
      dialogDef
        .afterClosed()
        .pipe(take(1))
        .subscribe(answer => {
          this.groupService.getUsersOf(this.group_id).subscribe(result => {
            this.userList =  result
          })

        });
    }

    handleAddResourceDialog(): void {
      const dialogData = {data: {group: this.group_id,}};
      const dialogDef = this.dialog_.open(AddResourceComponent, dialogData);
      dialogDef
        .afterClosed()
        .pipe(take(1))
        .subscribe(answer => {
          this.groupService.getResourcesOf(this.group_id).subscribe(result => {
            this.resourcesList =  result.map( (resource: any) => {return {name: resource}})
          })

        });
    }

    handleDeleteResourceFromGroupDialog(resource_name:string): void {

      this.groupService.deleteResourceOfGroup({group: this.group_id, name: resource_name})
      .subscribe(_ => {
        if(!_.status){
          const config = {
            title: 'Erreur',
            message: 'Une erreur est survenue lors de la suppression de cette ressource : ' + _.message,
            confirmLabel: 'OK'
          } as AlertDialogConfig;
          this.dialog_.open(AlertDialog, {data: config});
        }else{
          const config = {
            title: 'Supprimée !',
            message: _.message,
            confirmLabel: 'OK'
          } as AlertDialogConfig;
          this.dialog_.open(AlertDialog, {data: config});
          this.groupService.getResourcesOf(this.group_id).subscribe(result => {
            this.resourcesList =  result.map( (resource: any) => {return {name: resource}})
          })
        }
      },
      error => {
        const config = {
          title: 'Erreur',
          message: 'Une erreur est survenue lors de la suppression : ' + error,
          confirmLabel: 'OK'
        } as AlertDialogConfig;
        this.dialog_.open(AlertDialog, {data: config});
        return throwError(error);
      })

    }

    handleDeleteUserFromGroupDialog(resource_id:string): void {

      this.groupService.deleteUserOfGroup({group: this.group_id, email: resource_id})
      .subscribe(_ => {
        if(!_.status){
          const config = {
            title: 'Erreur',
            message: 'Une erreur est survenue lors de la suppression de cette ressource : ' + _.message,
            confirmLabel: 'OK'
          } as AlertDialogConfig;
          this.dialog_.open(AlertDialog, {data: config});
        }else{
          const config = {
            title: 'Supprimée !',
            message: _.message,
            confirmLabel: 'OK'
          } as AlertDialogConfig;
          this.dialog_.open(AlertDialog, {data: config});
          this.groupService.getUsersOf(this.group_id).subscribe(result => {
            this.userList =  result
          })
        }
      },
      error => {
        const config = {
          title: 'Erreur',
          message: 'Une erreur est survenue lors de la suppression : ' + error,
          confirmLabel: 'OK'
        } as AlertDialogConfig;
        this.dialog_.open(AlertDialog, {data: config});
        return throwError(error);
      })

    }
}
